<p-panel  [header]="caption" [toggleable]="true" [collapsed]="true">
  <ng-template pTemplate="icons">

</ng-template>
<div class="flex justify-content-between">
  <p-selectButton [options]="modes" [(ngModel)]="mode" optionLabel="name" optionValue="code" (onChange)="onModeChanged($event)"></p-selectButton>
  <button pButton pRipple type="button" label="Обновить" icon="pi pi-refresh" class="p-button-secondary" (click)="onRefresh()"></button>
</div>
  <apx-chart [series]="graphOptions.series" [chart]="graphOptions.chart" [dataLabels]="graphOptions.dataLabels"
    [markers]="graphOptions.markers" [title]="graphOptions.title" [fill]="graphOptions.fill"
    [yaxis]="graphOptions.yaxis" [xaxis]="graphOptions.xaxis" [tooltip]="graphOptions.tooltip"
    [autoUpdateSeries]="true"></apx-chart>
</p-panel >
